import axios from 'axios';

import globalHelper from '@/helpers/global.helper';
import { ErrorValidation } from '@/http/error-interceptor';
import store from '../store';

const AxiosInstance = (msName = null) => {
    const $axios = axios.create({
        withCredentials: true
    });

    if(msName){
        $axios.defaults.baseURL = `${window.VUE_APP_MS_URL}${msName}/`;
    }

    // Add a request interceptor
    $axios.interceptors.request.use((conf) => {
        const source = axios.CancelToken.source();
			// Set cancel token on this request
			conf.cancelToken = source.token;
        // Add to vuex to make cancellation available from anywhere
        store.commit('addCancelToken', source);

        const currentToken = globalHelper.getCurData('curToken');
        if (currentToken) {
            conf.headers.Authorization = 'Bearer ' + currentToken;
        }
        
        return conf;
    }, (error) => {
        // Do something with request error
        return Promise.reject(error);
    });

    // After API response Callback
    $axios.interceptors.response.use(response => {
        return response;
    }, async (error) => {
        await ErrorValidation(error);
        // Do something with response error
        return Promise.reject(error);
    });
 
    return $axios;
}


export default AxiosInstance;
